import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import DownloadButton from "../../../../common/batches/DownloadButton";
import EditButton from "../../../../common/batches/EditButton";
import PendingButton from "../../../../common/batches/PendingButton";
import RejectButton from "../../../../common/batches/RejectButton";
import RejectedButton from "../../../../common/batches/RejectedButton";
import VerifiedButton from "../../../../common/batches/VerifiedButton";
import VerifyButton from "../../../../common/batches/VerifyButton";
import ViewButton from "../../../../common/batches/ViewButton";
import ErrorHandler from "../../../../common/ErrorHandler";
import { indianCurrencyFormater } from "../../../../helpers/functions/currencyFormater";
import { formatDateDDMMYYYY } from "../../../../helpers/functions/dateFormatter";
import { documentHeaderLabel } from "../common/fields";
import useOnBoardingViewDetails from "../hooks/useOnBoardingViewDetails";
import "../styles/onboarding.css";
import DownloadZipDoc from "./DownloadZip";
import CaseRenewalsPanel from "./CaseRenewalsPanel";
import AuctionERPBreadcrumb from "../../../../common/Breadcrumb/AuctionERPBreadcumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const PRIVILEGED_EDITOR_PHONE = "9175894368";

function OnBoardingViewDetails() {
  const { id } = useParams();
  const userId = parseInt(id.split(":")[1]);
  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);
  const history = useHistory();
  const location = useLocation();
  const [isMediumDevice, setisMediumDevice] = useState(
    window.innerWidth >= 768,
  );
  const [expandedPartners, setExpandedPartners] = useState({});

  useEffect(() => {
    document.title = "On Boarding View Details";

    const handleResize = () => {
      setisMediumDevice(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const {
    selected,
    setSelected,
    loadingTADetails,
    handleUpload,
    handleVerifiedrRejected,
    handleVerifiedrRejectedBusDetails,
    loadingbusDetails,
    filterTAUserDetails,
    handleBusinessProofChange,
    businessProofSelections,
    handleChangePassword,
    handleDeleteCase,
    handleVerifyAll,
    showDocList,
    downloadDocumentsAsZip,
    selectDocList,
    setShowDocList,
    setDocHeader,
    originalDocHeader,
    setLimitSettingDocHeader,
    originallimitSettingDocumentsHeaderv,
    handleSearch,
    docHeader,
    businessHeaderv,
    handleSearchLimitSetting,
    limitSettingDocHeader,
  } = useOnBoardingViewDetails({ id: userId ? userId : "" });
  let peronData = [];

  if (filterTAUserDetails?.partnerDetails) {
    peronData = filterTAUserDetails?.partnerDetails;
  }
  useEffect(() => {
    document.title = "TA Onboarding Details";
  }, []);

  const breadcrumbItems = [
    { name: "Home", link: "/dashboard/trade_advance/onboarding" },
    {
      name: "Case Details",
      link: "/dashboard/trade_advance/onboarding/case_details",
    },
  ];

  // Helper function to check if user has Developer designation for current state
  const hasDeveloperDesignation = () => {
    if (!user?.assigned_states_designations || !user?.state) {
      return false;
    }

    const currentStateData = user.assigned_states_designations.find(
      (stateData) => stateData.state === user.state,
    );

    if (!currentStateData || !currentStateData.designations) {
      return false;
    }

    return currentStateData.designations.some(
      (designation) =>
        designation.designation === "Developer" ||
        designation.designation === "Tech Head",
    );
  };

  const isDeveloper = hasDeveloperDesignation();

  // Developers and this one phone number may edit business details and upload
  // documents until limit setting is done, even after the BA approved the case.
  const isPrivilegedEditor =
    isDeveloper || String(user?.phone) === PRIVILEGED_EDITOR_PHONE;
  const canPrivilegedEdit =
    isPrivilegedEditor && !filterTAUserDetails?.isLimitSettingDone;

  try {
    return (
      <>
        {showDocList && (
          <DownloadZipDoc
            show={showDocList}
            downloadDocumentsAsZip={downloadDocumentsAsZip}
            data={selectDocList}
            documentsList={filterTAUserDetails?.documents}
            onHide={() => setShowDocList(false)}
          />
        )}
        {user.role === "Auction Representative" ? (
          <>
            <AuctionERPBreadcrumb items={breadcrumbItems} />
          </>
        ) : (
          <>
            <div className="container-fluid shadow-sm">
              <div className="container">
                <div className="row">
                  <div className="d-sm-block d-md-none d-lg-none d-xl-none">
                    <div className="row">
                      <div className="col-12">
                        <h1 style={{ fontSize: "28px" }}>{user.name}</h1>
                      </div>
                      <div className="col-12">
                        <h1 style={{ fontSize: "28px" }}>{user.role}</h1>
                      </div>
                    </div>
                  </div>

                  <div className="d-none d-md-block d-lg-none d-xl-none">
                    <div className="row">
                      <div className="col-12 col-md-6 mt-4 ">
                        <h2 className="m4">{user.name}</h2>
                      </div>
                      <div className="col-12 col-md-6 mt-4 mb-4">
                        <h1 style={{ fontSize: "28px" }}>{user.role}</h1>
                      </div>
                    </div>
                  </div>

                  <div className="d-none d-md-none d-lg-block d-xl-block">
                    <div className="row">
                      <div className="col-12 col-md-8 mt-4 ">
                        <h2 className="m4">{user.name}</h2>
                      </div>
                      <div className="col-12 col-md-4 mt-4 mb-4">
                        <h1 style={{ fontSize: "28px" }}>{user.role}</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container mt-3">
              <div className="d-flex justify-content-between">
                <i
                  className="bi bi-arrow-left-circle"
                  onClick={() => {
                    if (user?.role === "Auction Representative") {
                      history.push(
                        "/auction_representative/user_home/manage-ta-onboard",
                      );
                    } else if (user?.role === "Business Analyst") {
                      history.push(
                        `/business_analyst:${user?.phone}&state=${user?.state}`,
                      );
                    } else {
                      history.goBack();
                    }
                  }}
                  style={{
                    fontSize: "xx-large",
                    color: "black",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                ></i>
              </div>
            </div>
          </>
        )}

        <div className="container mt-3" style={{ paddingBottom: 56 }}>
          {loadingTADetails ? (
            Array.from({ length: 3 }).map((_, index) => (
              <div
                key={index}
                className="container shadow-sm p-3 mb-2 border mt-4"
                style={{ borderRadius: "7px", backgroundColor: "#f4f4f4" }}
              >
                <div className="placeholder-glow">
                  <div
                    className="mb-2"
                    style={{
                      width: "60%",
                      height: "20px",
                      backgroundColor: "#e0e0e0",
                    }}
                  />
                  <div
                    className="mb-2"
                    style={{
                      width: "80%",
                      height: "16px",
                      backgroundColor: "#e0e0e0",
                    }}
                  />
                  <div
                    className="mb-2"
                    style={{
                      width: "40%",
                      height: "16px",
                      backgroundColor: "#e0e0e0",
                    }}
                  />
                </div>
              </div>
            ))
          ) : (
            <>
              {!loadingTADetails &&
              Object.entries(filterTAUserDetails) &&
              Object.entries(filterTAUserDetails).length > 0 ? (
                <>
                  <div className="col-12 col-sm-5 col-lg-4 col-xl-3">
                    <h5>TA User Details </h5>
                  </div>
                  <div className="d-flex flex-wrap justify-content-between">
                    <div className="col-12 col-md-4">
                      <div
                        className="shadow-sm bg-glass p-3 mb-2 border mt-3"
                        style={{
                          backgroundColor: "rgb(255,255,255)",
                          minHeight: "18rem",
                          maxHeight: "21rem",
                        }}
                      >
                        <div className="col-12">
                          <div
                            className="col-12  text-bold"
                            style={{
                              fontWeight: 600,
                              fontFamily: "ui-monospace",
                            }}
                          >
                            Dealer Information
                          </div>
                          <div className="col-12  text-bold">
                            <div
                              style={{
                                fontWeight: 400,
                                fontFamily: "none",
                                color: "rgb(192,190,190)",
                              }}
                            >
                              ID
                            </div>
                            <div
                              className=""
                              style={{
                                fontWeight: 600,
                                fontFamily: "none",
                                marginTop: "-2px",
                              }}
                            >
                              {filterTAUserDetails?.taOnboardingCaseId}
                            </div>
                          </div>
                          <div className="col-12  text-bold">
                            <div
                              style={{
                                fontWeight: 400,
                                fontFamily: "none",
                                color: "rgb(192,190,190)",
                              }}
                            >
                              Location
                            </div>
                            <div
                              className=""
                              style={{
                                fontWeight: 600,
                                fontFamily: "none",
                                marginTop: "-2px",
                              }}
                            >
                              {filterTAUserDetails?.companyAddress}
                            </div>
                          </div>
                          <div className="col-12  text-bold">
                            <div
                              style={{
                                fontWeight: 400,
                                fontFamily: "none",
                                color: "rgb(192,190,190)",
                              }}
                            >
                              TA User Name
                            </div>
                            <div
                              className=""
                              style={{
                                fontWeight: 600,
                                fontFamily: "monospace",
                                marginTop: "-2px",
                              }}
                            >
                              {filterTAUserDetails?.personName}
                            </div>
                          </div>
                          <div className="col-12  text-bold">
                            <div
                              style={{
                                fontWeight: 400,
                                fontFamily: "none",
                                color: "rgb(192,190,190)",
                              }}
                            >
                              Phone
                            </div>
                            <div
                              className=""
                              style={{
                                fontWeight: 600,
                                fontFamily: "none",
                                marginTop: "-2px",
                              }}
                            >
                              {filterTAUserDetails?.taUserPhone}
                            </div>
                          </div>
                          <div className="col-12  text-bold">
                            <div
                              style={{
                                fontWeight: 400,
                                fontFamily: "none",
                                color: "rgb(192,190,190)",
                              }}
                            >
                              Email
                            </div>
                            <div
                              className="flex-wrap"
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                wordBreak: "break-word",
                                fontWeight: 600,
                                fontFamily: "none",
                                marginTop: "-2px",
                              }}
                            >
                              {filterTAUserDetails?.email}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-12 col-md-8"
                      style={{ marginRight: "-10px" }}
                    >
                      <div
                        className="shadow-sm bg-glass p-3 mb-2 border mt-3 onBordingCard"
                        style={{
                          backgroundColor: "rgb(255,255,255)",
                          maxHeight: "18rem",
                          minHeight: "18rem",
                        }}
                      >
                        <div
                          className="col-12 mb-2 text-bold"
                          style={{
                            fontWeight: 600,
                            fontFamily: "ui-monospace",
                          }}
                        >
                          Documents Status
                        </div>
                        <div className="d-flex flex-wrap justify-content-between flex-sm-row gap-1 ">
                          <div
                            className="onBordingScreenSize"
                            style={{
                              fontSize: "10px",
                              backgroundColor: "rgb(220,252,231)",
                              color: "rgb(122,175,159)",
                            }}
                          >
                            <h5 className="text-center m-0">
                              {" "}
                              {filterTAUserDetails?.verified}{" "}
                            </h5>

                            <h6 className="text-center">Verified</h6>
                          </div>
                          <div
                            className="onBordingScreenSize"
                            style={{
                              fontSize: "10px",
                              fontWeight: 500,
                              backgroundColor: "rgb(254,226,226)",
                              color: "rgb(208,122,128)",
                            }}
                          >
                            <h5 className="text-center m-0">
                              {" "}
                              <h5 className="text-center m-0">
                                {filterTAUserDetails?.rejected}
                              </h5>
                            </h5>
                            <h6 className="text-center">Rejected</h6>
                          </div>
                          <div
                            className="onBordingScreenSize"
                            style={{
                              fontSize: "10px",
                              fontWeight: 500,
                              backgroundColor: "rgb(254,216,216)",
                              color: "rgb(208,122,128)",
                            }}
                          >
                            <h5 className="text-center m-0">
                              {" "}
                              <h5 className="text-center m-0">
                                {" "}
                                {filterTAUserDetails?.missing}
                              </h5>
                            </h5>
                            <h6 className="text-center">Missing</h6>
                          </div>
                          <div
                            className="onBordingScreenSize"
                            style={{
                              fontSize: "10px",
                              fontWeight: 500,
                              backgroundColor: "rgb(243,244,246)",
                              color: "rgb(192,172,165)",
                            }}
                          >
                            <h5 className="text-center m-0">
                              <h5 className="text-center m-0">
                                {filterTAUserDetails?.pending}
                              </h5>
                            </h5>
                            <h6 className="text-center">Pending</h6>
                          </div>
                        </div>

                        <div
                          className="d-flex flex-wrap justify-content-end col-12 mb-2 text-bold text-end gap-1"
                          style={{
                            fontWeight: 600,
                            fontFamily: "ui-monospace",
                            marginTop: isMediumDevice ? "7rem" : "1rem",
                          }}
                        >
                          {user?.role === "Business Analyst" &&
                            !filterTAUserDetails?.isCaseApprovedByBa && (
                              <>
                                <div
                                  className="text-start text-md-end"
                                  style={{ marginRight: "10px" }}
                                >
                                  <button
                                    className="btn btn-light shadow-sm"
                                    style={{
                                      fontSize: "12px",
                                      color: "rgb(40, 180, 255)",
                                      backgroundColor: "rgb(254, 254, 254)",
                                      marginLeft: "2px",
                                    }}
                                    onClick={(e) => {
                                      handleVerifyAll(
                                        e,
                                        filterTAUserDetails?.taOnboardingCaseId,
                                        "approve",
                                      );
                                    }}
                                  >
                                    <i
                                      class="bi bi-check2"
                                      style={{ fontSize: "10px", top: 2 }}
                                    ></i>
                                    All Verified
                                  </button>
                                </div>
                              </>
                            )}
                          {user?.role === "Business Analyst" &&
                            !filterTAUserDetails?.isLosApplicationIdUpdated && (
                              <>
                                {" "}
                                <div
                                  className="text-end"
                                  style={{ marginRight: "0px" }}
                                >
                                  <button
                                    className="btn btn-danger"
                                    style={{ fontSize: "12px" }}
                                    onClick={(e) => {
                                      handleDeleteCase(
                                        e,
                                        filterTAUserDetails?.taOnboardingCaseId,
                                      );
                                    }}
                                  >
                                    <i
                                      class="bi bi-trash me-2"
                                      // style={{ fontSize: "10px" }}
                                    ></i>
                                    Delete Case
                                  </button>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="btn-group mt-2 p-1 w-100"
                    role="group"
                    aria-label="Basic radio toggle button group"
                    style={{
                      backgroundColor: "rgb(244,244,245)",
                      // maxWidth: "42rem",
                      minWidth: "25px",
                      // overflow: "scroll",
                    }}
                  >
                    <input
                      type="radio"
                      className="btn-check"
                      name="btnradio"
                      id="bussRadio"
                      autoComplete="off"
                      checked={selected === "buss"}
                      onChange={() => setSelected("buss")}
                    />
                    <label
                      className="btn"
                      htmlFor="bussRadio"
                      style={{
                        backgroundColor:
                          selected === "buss" ? "#fff" : "rgb(244,244,245)",
                        color: selected === "buss" ? "#000" : "#999",
                        fontWeight: selected === "buss" ? 500 : 400,
                        border: "0px solid #ccc",
                        borderLeft: "none",
                        borderRadius: "0",
                        padding: "5px 4px",
                      }}
                    >
                      <i
                        className="bi bi-person"
                        style={{
                          marginRight: "6px",
                          color:
                            selected === "buss" ? "rgb(75,107,134)" : "#ccc",
                        }}
                      ></i>
                      Business Details
                    </label>
                    <input
                      type="radio"
                      className="btn-check"
                      name="btnradio"
                      id="docRadio"
                      autoComplete="off"
                      checked={selected === "doc"}
                      onChange={() => {
                        setSelected("doc");
                        setDocHeader(originalDocHeader);
                      }}
                    />
                    <label
                      className="btn"
                      htmlFor="docRadio"
                      style={{
                        backgroundColor:
                          selected === "doc" ? "#fff" : "rgb(244,244,245)",
                        color: selected === "doc" ? "#000" : "#999",
                        fontWeight: selected === "doc" ? 500 : 400,
                        border: "0px solid #ccc",
                        borderRadius: "0",
                        padding: "5px 4px",
                      }}
                    >
                      <i
                        className="bi bi-file-earmark-text"
                        style={{
                          marginRight: "6px",
                          color:
                            selected === "doc" ? "rgb(75,107,134)" : "#ccc",
                        }}
                      ></i>
                      Documents
                    </label>
                    {filterTAUserDetails?.isLimitSettingAllDocumentUploaded && (
                      <>
                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio"
                          id="limitSettingDocRadio"
                          autoComplete="off"
                          checked={selected === "limitSettingDoc"}
                          onChange={() => {
                            setSelected("limitSettingDoc");
                            setLimitSettingDocHeader(
                              originallimitSettingDocumentsHeaderv,
                            );
                          }}
                        />
                        <label
                          className="btn"
                          htmlFor="limitSettingDocRadio"
                          style={{
                            backgroundColor:
                              selected === "limitSettingDoc"
                                ? "#fff"
                                : "rgb(244,244,245)",
                            color:
                              selected === "limitSettingDoc" ? "#000" : "#999",
                            fontWeight:
                              selected === "limitSettingDoc" ? 500 : 400,
                            border: "0px solid #ccc",
                            borderRadius: "0",
                            padding: "5px 4px",
                          }}
                        >
                          <i
                            className="bi bi-file-earmark-text"
                            style={{
                              marginRight: "6px",
                              color:
                                selected === "limitSettingDoc"
                                  ? "rgb(75,107,134)"
                                  : "#ccc",
                            }}
                          ></i>
                          Limit Setting Documents
                        </label>
                      </>
                    )}
                    {filterTAUserDetails?.isLimitSettingDone && (
                      <>
                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio"
                          id="limitSettingRadio"
                          autoComplete="off"
                          checked={selected === "limitSetting"}
                          onChange={() => setSelected("limitSetting")}
                        />
                        <label
                          className="btn"
                          htmlFor="limitSettingRadio"
                          style={{
                            backgroundColor:
                              selected === "limitSetting"
                                ? "#fff"
                                : "rgb(244,244,245)",
                            color:
                              selected === "limitSetting" ? "#000" : "#999",
                            fontWeight: selected === "limitSetting" ? 500 : 400,
                            border: "0px solid #ccc",
                            borderRadius: "0",
                            padding: "5px 4px",
                          }}
                        >
                          <i
                            className="bi bi-file-earmark-text"
                            style={{
                              marginRight: "6px",
                              color:
                                selected === "limitSetting"
                                  ? "rgb(75,107,134)"
                                  : "#ccc",
                            }}
                          ></i>
                          Limit Setting
                        </label>

                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio"
                          id="renewalsRadio"
                          autoComplete="off"
                          checked={selected === "renewals"}
                          onChange={() => setSelected("renewals")}
                        />
                        <label
                          className="btn"
                          htmlFor="renewalsRadio"
                          style={{
                            backgroundColor:
                              selected === "renewals"
                                ? "#fff"
                                : "rgb(244,244,245)",
                            color: selected === "renewals" ? "#000" : "#999",
                            fontWeight: selected === "renewals" ? 500 : 400,
                            border: "0px solid #ccc",
                            borderRadius: "0",
                            padding: "5px 4px",
                          }}
                        >
                          <i
                            className="bi bi-arrow-repeat"
                            style={{
                              marginRight: "6px",
                              color:
                                selected === "renewals"
                                  ? "rgb(75,107,134)"
                                  : "#ccc",
                            }}
                          ></i>
                          Renewals
                        </label>
                      </>
                    )}
                  </div>

                  {selected === "doc" && (
                    <>
                      {/* Partner Documents Section - Only for Partnership business type */}
                      {(filterTAUserDetails?.businessType?.toLowerCase() ===
                        "partnership" ||
                        filterTAUserDetails?.businessType ===
                          "Private limited (Pvt Ltd)") &&
                        filterTAUserDetails?.partnerDetails &&
                        filterTAUserDetails?.partnerDetails.length > 0 && (
                          <div className="mt-4 mb-4">
                            <h5
                              className="mb-3"
                              style={{ color: "rgb(46,50,48)" }}
                            >
                              Partner Documents
                            </h5>
                            {filterTAUserDetails?.partnerDetails.map(
                              (partner, partnerIndex) => {
                                const isExpanded =
                                  expandedPartners[partner.partnerID] !== false;

                                // Calculate counts for this partner
                                const partnerDocs = partner.documents || [];
                                const partnerCounts = {
                                  verified: partnerDocs.filter(
                                    (d) => d.isApproved,
                                  ).length,
                                  rejected: partnerDocs.filter(
                                    (d) => d.isRejected,
                                  ).length,
                                  missing: partnerDocs.filter(
                                    (d) => !d.isUploaded,
                                  ).length,
                                  pending: partnerDocs.filter(
                                    (d) =>
                                      d.isUploaded &&
                                      !d.isApproved &&
                                      !d.isRejected,
                                  ).length,
                                };

                                return (
                                  <div key={partner.partnerID} className="mb-4">
                                    {/* Partner Accordion Container */}
                                    <div
                                      className="shadow-sm border"
                                      style={{
                                        backgroundColor: isExpanded
                                          ? "rgb(255,255,255)"
                                          : "rgb(248,249,250)",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {/* Partner Header */}
                                      <div
                                        className="p-3"
                                        style={{
                                          backgroundColor: "rgb(248,249,250)",
                                          cursor: "pointer",
                                          borderBottom: isExpanded
                                            ? "1px solid rgb(229,231,235)"
                                            : "none",
                                        }}
                                        onClick={() => {
                                          setExpandedPartners((prev) => ({
                                            ...prev,
                                            [partner.partnerID]: !isExpanded,
                                          }));
                                        }}
                                      >
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div className="d-flex flex-wrap align-items-center w-100">
                                            <div className="flex-grow-1">
                                              <h6
                                                className="mb-1"
                                                style={{ fontWeight: 600 }}
                                              >
                                                Partner {partnerIndex + 1}:{" "}
                                                {partner.personName}
                                              </h6>
                                            </div>
                                            <div className="d-flex flex-wrap gap-2 align-items-center">
                                              {partnerCounts.verified > 0 && (
                                                <span
                                                  className="badge"
                                                  style={{
                                                    fontSize: "0.75rem",
                                                    backgroundColor:
                                                      "rgb(220,252,231)",
                                                    color: "rgb(22,163,74)",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  <i className="bi bi-check-circle-fill me-1"></i>
                                                  Verified:{" "}
                                                  {partnerCounts.verified}
                                                </span>
                                              )}
                                              {partnerCounts.rejected > 0 && (
                                                <span
                                                  className="badge"
                                                  style={{
                                                    fontSize: "0.75rem",
                                                    backgroundColor:
                                                      "rgb(254,226,226)",
                                                    color: "rgb(220,38,38)",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  <i className="bi bi-x-circle-fill me-1"></i>
                                                  Rejected:{" "}
                                                  {partnerCounts.rejected}
                                                </span>
                                              )}
                                              {partnerCounts.missing > 0 && (
                                                <span
                                                  className="badge"
                                                  style={{
                                                    fontSize: "0.75rem",
                                                    backgroundColor:
                                                      "rgb(254,216,216)",
                                                    color: "rgb(185,28,28)",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  <i className="bi bi-file-earmark-excel me-1"></i>
                                                  Missing:{" "}
                                                  {partnerCounts.missing}
                                                </span>
                                              )}
                                              {partnerCounts.pending > 0 && (
                                                <span
                                                  className="badge"
                                                  style={{
                                                    fontSize: "0.75rem",
                                                    backgroundColor:
                                                      "rgb(243,244,246)",
                                                    color: "rgb(234,179,8)",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  <i className="bi bi-clock-fill me-1"></i>
                                                  Pending:{" "}
                                                  {partnerCounts.pending}
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                          <i
                                            className={`bi ${isExpanded ? "bi-chevron-up" : "bi-chevron-down"} ms-2`}
                                            style={{ fontSize: "1.2rem" }}
                                          ></i>
                                        </div>
                                      </div>

                                      {/* Partner Documents */}
                                      <div
                                        style={{
                                          display: isExpanded
                                            ? "block"
                                            : "none",
                                          padding: isExpanded ? "15px" : "0",
                                        }}
                                      >
                                        {partner.documents &&
                                        partner.documents.length > 0 ? (
                                          <div className="row">
                                            {partner.documents.map((doc) => {
                                              const docLabels = {
                                                aadhar_front:
                                                  "Aadhar Card Front",
                                                aadhar_back: "Aadhar Card Back",
                                                pan: "PAN Card",
                                              };

                                              return (
                                                <div
                                                  className="col-12 col-lg-4 mx-0"
                                                  key={`${partner.partnerID}-${doc.documentName}`}
                                                >
                                                  <div
                                                    className="shadow-sm px-3 py-2 mb-2 rounded border"
                                                    style={{ height: "100%" }}
                                                  >
                                                    <div className="d-flex flex-column">
                                                      <div className="d-flex align-items-center mb-2">
                                                        <div
                                                          style={{
                                                            fontSize: "31px",
                                                            marginRight: "5px",
                                                            marginLeft: "-3px",
                                                            color:
                                                              "rgb(173, 106, 246)",
                                                          }}
                                                        >
                                                          <i className="bi bi-file-image-fill"></i>
                                                        </div>
                                                        <div className="d-flex flex-row justify-content-between w-100 align-items-center">
                                                          <span
                                                            style={{
                                                              fontWeight: 500,
                                                            }}
                                                          >
                                                            {doc.documentLabel ||
                                                              docLabels[
                                                                doc.documentName
                                                              ] ||
                                                              doc.documentName}
                                                            <strong className="text-danger">
                                                              {" "}
                                                              *
                                                            </strong>
                                                          </span>
                                                          <div>
                                                            {doc.isApproved && (
                                                              <div className="flex items-center space-x-2 text-gray-500">
                                                                <div className="d-flex align-items-center text-muted mt-1">
                                                                  <i className="bi bi-check-lg text-success fs-8 me-1"></i>
                                                                  <span className="text-sm text-success">
                                                                    Verified
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            )}
                                                            {doc.isRejected && (
                                                              <div className="flex items-center space-x-2 text-gray-500">
                                                                <div className="d-flex align-items-center text-muted mt-1">
                                                                  <FontAwesomeIcon
                                                                    icon={
                                                                      faXmark
                                                                    }
                                                                    className="me-1"
                                                                    style={{
                                                                      paddingTop:
                                                                        "2px",
                                                                    }}
                                                                  />
                                                                  <span className="text-sm text-dark">
                                                                    Rejected
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            )}
                                                            {!doc.isApproved &&
                                                              doc.isUploaded &&
                                                              !doc.isRejected &&
                                                              doc.documentPath && (
                                                                <div className="flex items-center space-x-2 text-gray-500">
                                                                  <div className="d-flex align-items-center text-muted mt-1">
                                                                    <i className="bi bi-clock text-warning fs-8 me-1"></i>
                                                                    <span className="text-sm text-warning">
                                                                      Pending
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              )}
                                                            {!doc.isUploaded && (
                                                              <div className="flex items-center space-x-2 text-gray-500">
                                                                <div className="d-flex align-items-center text-muted mt-1">
                                                                  <i className="bi bi-file-earmark-excel text-danger fs-8 me-1"></i>
                                                                  <span className="text-sm text-danger">
                                                                    No doc
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div className="d-flex flex-wrap gap-1">
                                                        {/* Upload button for Business Analyst, Auction Representative, and Developer */}
                                                        {(((user?.role ===
                                                          "Business Analyst" ||
                                                          user?.role ===
                                                            "Auction Representative") &&
                                                          !filterTAUserDetails?.isCaseApprovedByBa &&
                                                          (!doc.isUploaded ||
                                                            doc.isRejected)) ||
                                                          canPrivilegedEdit) && (
                                                          <label
                                                            htmlFor={`partner-${partner.partnerID}-${doc.documentName}`}
                                                            className="btn btn-outline-primary btn-sm mb-0"
                                                          >
                                                            Upload
                                                            <input
                                                              type="file"
                                                              id={`partner-${partner.partnerID}-${doc.documentName}`}
                                                              name={
                                                                doc.documentName
                                                              }
                                                              style={{
                                                                display: "none",
                                                              }}
                                                              onChange={(e) =>
                                                                handleUpload(
                                                                  e,
                                                                  doc.documentName,
                                                                  doc.documentId,
                                                                  filterTAUserDetails?.taOnboardingCaseId,
                                                                  true,
                                                                  doc.documentLabel ||
                                                                    docLabels[
                                                                      doc
                                                                        .documentName
                                                                    ],
                                                                  partner.partnerID,
                                                                )
                                                              }
                                                            />
                                                          </label>
                                                        )}

                                                        {doc.documentPath && (
                                                          <>
                                                            <ViewButton
                                                              file={
                                                                doc.documentPath
                                                              }
                                                              className="btn btn-outline-light"
                                                            />
                                                            {!doc.isRejected && (
                                                              <DownloadButton
                                                                file={
                                                                  doc.documentPath
                                                                }
                                                              />
                                                            )}
                                                          </>
                                                        )}

                                                        {/* Verify button for Business Analyst */}
                                                        {user?.role ===
                                                          "Business Analyst" &&
                                                          doc.isUploaded &&
                                                          !doc.isApproved &&
                                                          !doc.isRejected && (
                                                            <VerifyButton
                                                              handleVerified={(
                                                                e,
                                                              ) =>
                                                                handleVerifiedrRejected(
                                                                  e,
                                                                  filterTAUserDetails?.taOnboardingCaseId,
                                                                  doc.documentId,
                                                                  "approve",
                                                                  doc.documentName,
                                                                  doc.documentLabel ||
                                                                    docLabels[
                                                                      doc
                                                                        .documentName
                                                                    ],
                                                                  partner.partnerID,
                                                                )
                                                              }
                                                            />
                                                          )}

                                                        {/* Reject button for Business Analyst */}
                                                        {user?.role ===
                                                          "Business Analyst" &&
                                                          doc.isUploaded &&
                                                          !doc.isRejected &&
                                                          !filterTAUserDetails?.isCaseApprovedByBa && (
                                                            <RejectButton
                                                              handleVerified={(
                                                                e,
                                                              ) =>
                                                                handleVerifiedrRejected(
                                                                  e,
                                                                  filterTAUserDetails?.taOnboardingCaseId,
                                                                  doc.documentId,
                                                                  "reject",
                                                                  doc.documentName,
                                                                  doc.documentLabel ||
                                                                    docLabels[
                                                                      doc
                                                                        .documentName
                                                                    ],
                                                                  partner.partnerID,
                                                                )
                                                              }
                                                            />
                                                          )}
                                                      </div>

                                                      {doc.isRejected && (
                                                        <div className="mt-2 text-danger">
                                                          <span>
                                                            Rejection
                                                            reason:{" "}
                                                          </span>
                                                          <span>
                                                            {doc.rejectionRemarks ||
                                                              "N/A"}
                                                          </span>
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </div>
                                        ) : (
                                          <div className="text-center text-muted p-3">
                                            No documents available for this
                                            partner
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              },
                            )}
                          </div>
                        )}

                      <div className="d-flex flex-wrap justify-content-between text-align-center">
                        <div className="col-12 col-md-6 col-lg-3">
                          <h5
                            className="mt-4"
                            style={{ color: "rgb(46,50,48)" }}
                          >
                            Documents
                          </h5>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                          <input
                            className="form-control"
                            name="search"
                            placeholder="Search by document name"
                            onChange={handleSearch}
                          />
                        </div>
                      </div>

                      {docHeader.map((doc) => {
                        const businessType =
                          filterTAUserDetails?.businessType?.toLowerCase();

                        if (
                          ((businessType === "individual" ||
                            businessType === "proprietor" ||
                            businessType === "private limited (Pvt Ltd)") &&
                            doc.dataKey === "partnership_deed") ||
                          ((businessType === "individual" ||
                            businessType === "proprietor") &&
                            (doc.dataKey === "firm_pan" ||
                              doc.dataKey === "partnership_deed")) ||
                          ((businessType === "partnership" ||
                            businessType === "private limited (pvt ltd)") &&
                            doc.dataKey === "pan") ||
                          ((businessType === "partnership" ||
                            businessType === "private limited (pvt ltd)") &&
                            (doc.dataKey === "aadhar_front" ||
                              doc.dataKey === "aadhar_back"))
                        ) {
                          return null;
                        }

                        // Hide tyger cheque documents if TA funding is by MT
                        if (
                          filterTAUserDetails?.isTAFundingByMT &&
                          (doc.dataKey === "tyger_cheque_1" ||
                            doc.dataKey === "tyger_cheque_2")
                        ) {
                          return null;
                        }

                        let isRequired = doc.required || false;

                        if (doc.dataKey === "pan") {
                          isRequired = ["individual", "proprietor"].includes(
                            businessType,
                          );
                        } else if (doc.dataKey === "firm_pan") {
                          const normalizedBusinessType = businessType
                            .trim()
                            .toLowerCase();

                          isRequired = [
                            "partnership",
                            "private limited (pvt ltd)",
                          ].includes(normalizedBusinessType);
                        } else if (doc.dataKey === "partnership_deed") {
                          const normalizedBusinessType = businessType
                            .trim()
                            .toLowerCase();

                          isRequired = ["partnership"].includes(
                            normalizedBusinessType,
                          );
                        }

                        const documentData =
                          filterTAUserDetails?.documents?.find(
                            (d) => d.documentName === doc.dataKey,
                          );
                        const fileUrl = documentData?.documentPath;

                        const isUploadAllowed = () => {
                          if (user?.role !== "Business Analyst" && !canPrivilegedEdit)
                            return false;

                          const { dataKey } = doc || {};
                          const {
                            itrYear1Available,
                            itrYear2Available,
                            businessProof2Name,
                            businessProof1Name,
                          } = filterTAUserDetails || {};
                          const { isUploaded, isRejected, isApproved } =
                            documentData || {};

                          const isUploadableState =
                            (!isUploaded && !isRejected && !isApproved) ||
                            (isUploaded && isRejected && !isApproved);

                          if (dataKey === "itr_year_1") {
                            if (itrYear1Available === "No") return false;
                            return isUploadableState;
                          }

                          if (dataKey === "itr_year_2") {
                            if (itrYear2Available === "No") return false;
                            return isUploadableState;
                          }
                          if (dataKey === "business_proof_1") {
                            if (businessProof1Name === "") return false;
                            return isUploadableState;
                          }
                          if (dataKey === "business_proof_2") {
                            if (businessProof2Name === "") return false;
                            return isUploadableState;
                          }

                          return isUploadableState;
                        };

                        const canUpload = isUploadAllowed();

                        return (
                          <div
                            className="shadow-sm p-3 mb-2 border mt-2"
                            key={doc.dataKey}
                          >
                            <div className="d-flex flex-wrap justify-content-between ">
                              <div className="d-flex flex-wrap justify-content-start align-center col-12 col-md-7">
                                <div
                                  style={{
                                    fontSize: "31px",
                                    marginRight: "5px",
                                    marginLeft: "-6px",
                                    color: "rgb(173, 106, 246)",
                                  }}
                                >
                                  <i
                                    className="bi bi-file-image-fill"
                                    style={{
                                      backgroundColor: "rgb(255,255,255)",
                                    }}
                                  ></i>
                                </div>
                                <div className="me-2">
                                  {user?.role === "Auction Representative" ||
                                  user?.role === "Business Analyst" ? (
                                    <span style={{ fontWeight: 500 }}>
                                      {doc.header}{" "}
                                      {isRequired === true && (
                                        <strong className="text-danger">
                                          *
                                        </strong>
                                      )}
                                    </span>
                                  ) : (
                                    <span style={{ fontWeight: 500 }}>
                                      {doc.header}
                                    </span>
                                  )}

                                  <div>
                                    {documentData?.isApproved && (
                                      <VerifiedButton />
                                    )}
                                    {documentData?.isRejected && (
                                      <RejectedButton />
                                    )}
                                    {!documentData?.isApproved &&
                                      documentData?.isUploaded &&
                                      !documentData?.isRejected &&
                                      documentData?.documentPath && (
                                        <PendingButton />
                                      )}
                                    {!documentData?.isUploaded && (
                                      <div className="flex items-center space-x-2 text-gray-500">
                                        <div className="d-flex align-items-center text-muted mt-1">
                                          <i className="bi bi-file-earmark-excel text-danger fs-8"></i>
                                          <span className="text-sm">
                                            No documents uploaded
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-4">
                                  {(user?.role === "Auction Representative" ||
                                    user?.role === "Business Analyst") &&
                                    (doc.dataKey === "business_proof_1" ||
                                      doc.dataKey === "business_proof_2" ||
                                      doc.dataKey === "itr_year_1" ||
                                      doc.dataKey === "itr_year_2") &&
                                    doc.options &&
                                    (() => {
                                      const fieldName =
                                        doc.dataKey === "business_proof_1"
                                          ? "businessProof1Name"
                                          : doc.dataKey === "business_proof_2"
                                            ? "businessProof2Name"
                                            : doc.dataKey === "itr_year_1"
                                              ? "itrYear1Available"
                                              : "itrYear2Available";
                                      const selectedValue =
                                        filterTAUserDetails?.[fieldName];
                                      const isDisabled =
                                        (documentData?.isUploaded &&
                                          !documentData?.isRejected) ||
                                        filterTAUserDetails?.isCaseApprovedByBa;
                                      const isSelectDisabled =
                                        user?.role ===
                                          "Auction Representative" &&
                                        filterTAUserDetails?.[fieldName] &&
                                        isDisabled &&
                                        filterTAUserDetails?.isCaseApprovedByBa;

                                      return (
                                        <select
                                          value={selectedValue}
                                          onChange={(e) =>
                                            handleBusinessProofChange(
                                              e.target.value,
                                              fieldName,
                                            )
                                          }
                                          disabled={
                                            user?.role ===
                                            "Auction Representative"
                                              ? filterTAUserDetails?.isCaseApprovedByBa ||
                                                documentData?.isApproved
                                              : filterTAUserDetails?.isCaseApprovedByBa
                                          }
                                          autoComplete="off"
                                          style={{ minWidth: 200 }}
                                          className="form-select"
                                        >
                                          <option
                                            value=""
                                            disabled={
                                              fieldName !== "businessProof2Name"
                                                ? true
                                                : false
                                            }
                                          >
                                            {`Select ${doc?.header}`}
                                          </option>
                                          {doc.options.map((opt) => (
                                            <option key={opt} value={opt}>
                                              {opt}
                                            </option>
                                          ))}
                                        </select>
                                      );
                                    })()}

                                  {doc.dataKey === "bank_statement" && (
                                    <>
                                      <label
                                        htmlFor="bankStatementPassword"
                                        className="form-label"
                                      >
                                        Bank Statement Password
                                      </label>
                                      <input
                                        style={{ marginTop: -3 }}
                                        type="text"
                                        disabled={
                                          user?.role ===
                                          "Auction Representative"
                                            ? filterTAUserDetails?.isCaseApprovedByBa ||
                                              documentData?.isApproved
                                            : filterTAUserDetails?.isCaseApprovedByBa
                                        }
                                        className="form-control"
                                        id="bankStatementPassword"
                                        name="bankStatementPassword"
                                        value={
                                          filterTAUserDetails?.bankStatementPassword
                                        }
                                        placeholder="Enter Statement Password"
                                        autoComplete="off"
                                        onChange={handleChangePassword}
                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              <div className="d-flex flex-row align-items-center justify-content-md-end justify-content-start col-12 col-md-5 mt-2 gap-1 text-md-end">
                                {((user?.role === "Auction Representative" &&
                                  !filterTAUserDetails?.isCaseApprovedByBa &&
                                  (documentData?.isRejected ||
                                    !documentData?.isUploaded)) ||
                                  canPrivilegedEdit) &&
                                  ((doc.dataKey !== "business_proof_1" &&
                                    doc.dataKey !== "business_proof_2" &&
                                    doc.dataKey !== "itr_year_1" &&
                                    doc.dataKey !== "itr_year_2") ||
                                    (doc.dataKey === "business_proof_1" &&
                                      (documentData?.isRejected ||
                                        businessProofSelections?.businessProof1Name)) ||
                                    (doc.dataKey === "itr_year_1" &&
                                      (documentData?.isRejected ||
                                        businessProofSelections?.itrYear1Available ===
                                          "Yes")) ||
                                    (doc.dataKey === "itr_year_2" &&
                                      (documentData?.isRejected ||
                                        businessProofSelections?.itrYear2Available ===
                                          "Yes")) ||
                                    (doc.dataKey === "business_proof_2" &&
                                      (documentData?.isRejected ||
                                        businessProofSelections?.businessProof2Name))) && (
                                    <div className="ms-1">
                                      <label
                                        htmlFor={doc.dataKey}
                                        className="btn btn-outline-primary btn-sm mb-0"
                                      >
                                        Upload
                                        <input
                                          type="file"
                                          id={doc.dataKey}
                                          name={doc.dataKey}
                                          style={{ display: "none" }}
                                          onChange={(e) =>
                                            handleUpload(
                                              e,
                                              doc.dataKey,
                                              documentData?.documentID,
                                              filterTAUserDetails?.taOnboardingCaseId,
                                              isRequired,
                                              doc?.header,
                                            )
                                          }
                                        />
                                      </label>
                                    </div>
                                  )}

                                {canUpload &&
                                  !filterTAUserDetails?.isCaseApprovedByBa &&
                                  !canPrivilegedEdit && (
                                    <div>
                                      <label
                                        htmlFor={doc.dataKey}
                                        className="btn btn-outline-primary btn-sm mb-0"
                                      >
                                        Upload
                                        <input
                                          type="file"
                                          id={doc.dataKey}
                                          name={doc.dataKey}
                                          style={{ display: "none" }}
                                          onChange={(e) =>
                                            handleUpload(
                                              e,
                                              doc.dataKey,
                                              documentData?.documentID,
                                              filterTAUserDetails?.taOnboardingCaseId,
                                              isRequired,
                                              doc?.header,
                                            )
                                          }
                                        />
                                      </label>
                                    </div>
                                  )}
                                {documentData?.documentPath && (
                                  <>
                                    <ViewButton
                                      file={fileUrl}
                                      className="btn btn-outline-light"
                                    />
                                    {!documentData?.isRejected && (
                                      <DownloadButton file={fileUrl} />
                                    )}
                                  </>
                                )}

                                {user?.role === "Business Analyst" &&
                                  documentData?.isUploaded &&
                                  !documentData?.isApproved &&
                                  !documentData?.isRejected && (
                                    <VerifyButton
                                      handleVerified={(e) =>
                                        handleVerifiedrRejected(
                                          e,
                                          filterTAUserDetails?.taOnboardingCaseId,
                                          documentData?.documentID,
                                          "approve",
                                          doc?.documentName,
                                          doc?.header,
                                        )
                                      }
                                    />
                                  )}

                                {user?.role === "Business Analyst" &&
                                  documentData?.isUploaded &&
                                  !documentData?.isRejected &&
                                  !location?.state?.peronData
                                    ?.isLimitSettingAllDocumentUploaded &&
                                  !filterTAUserDetails?.isCaseApprovedByBa && (
                                    <RejectButton
                                      handleVerified={(e) =>
                                        handleVerifiedrRejected(
                                          e,
                                          filterTAUserDetails?.taOnboardingCaseId,
                                          documentData?.documentID,
                                          "reject",
                                        )
                                      }
                                    />
                                  )}
                              </div>
                            </div>

                            {documentData?.isRejected && (
                              <div
                                style={{
                                  backgroundColor: "rgb(253,241,241)",
                                  color: "rgb(202,73,101)",
                                  marginTop: "15px",
                                  paddingTop: "10px",
                                  paddingBottom: "10px",
                                  paddingLeft: "5px",
                                }}
                              >
                                <span>Rejection reason: </span>
                                <span>{documentData?.rejectionRemarks}</span>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </>
                  )}

                  {selected === "buss" && (
                    <>
                      <h5 className="mt-4" style={{ color: "rgb(46,50,48)" }}>
                        Business Details
                        {filterTAUserDetails?.isCaseBusinessDetailsApprovedByBa ? (
                          <VerifiedButton />
                        ) : filterTAUserDetails?.isCaseBusinessDetailsRejectedByBa ? (
                          <RejectedButton />
                        ) : (
                          <PendingButton />
                        )}
                      </h5>
                      {/* <h5 className="mt-4" style={{ color: "rgb(46,50,48)" }}> */}
                      {filterTAUserDetails?.isCaseBusinessDetailsRejectedByBa && (
                        // <div
                        //   className=""
                        //   style={{
                        //     backgroundColor: "rgb(253,241,241)",
                        //     color: "rgb(202,73,101)",
                        //     marginTop: "15px",
                        //     paddingTop: "10px",
                        //     paddingBottom: "10px",
                        //     paddingLeft: "5px",
                        //   }}
                        // >
                        //   Rejection Reason :{" "}
                        //   <span className="d-flex flex-wrap text-align-start text-danger">
                        //     {
                        //       filterTAUserDetails?.caseBusinessDetailsRejectionReason
                        //     }
                        //   </span>
                        // </div>
                        <div
                          className="mt-3 px-2 py-2"
                          style={{
                            backgroundColor: "rgb(253,241,241)",
                            color: "rgb(202,73,101)",
                            borderRadius: "6px",
                          }}
                        >
                          <span>Rejection Reason :</span>
                          <span
                            className="text-danger"
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              marginTop: "5px",
                              marginLeft: "2px",
                            }}
                          >
                            {filterTAUserDetails?.caseBusinessDetailsRejectionReason ||
                              "N/A"}
                          </span>
                        </div>
                      )}
                      {/* </h5> */}

                      {/* Asset Metrics Summary */}
                      {filterTAUserDetails?.isTAFundingByMT && (
                        <>
                          <div className="d-flex align-items-center gap-2 mt-3 mb-2">
                            <i
                              className="bi bi-info-circle"
                              style={{
                                color: "rgb(107,114,128)",
                                fontSize: "1rem",
                              }}
                            ></i>
                            <span
                              style={{
                                fontSize: "0.875rem",
                                color: "rgb(107,114,128)",
                                fontWeight: "500",
                              }}
                            >
                              Last 3 Months Data
                            </span>
                          </div>
                          <div className="d-flex flex-wrap justify-content-between gap-2 mb-3">
                            <div
                              className="flex-grow-1"
                              style={{
                                backgroundColor: "rgb(254,243,199)",
                                color: "rgb(217,119,6)",
                                padding: "12px",
                                borderRadius: "8px",
                                textAlign: "center",
                                minWidth: "150px",
                                flex: "1 1 calc(33.333% - 8px)",
                              }}
                            >
                              <h5
                                className="text-center m-0"
                                style={{ fontWeight: "600" }}
                              >
                                {filterTAUserDetails?.totalAssetbidded || 0}
                              </h5>
                              <h6
                                className="text-center m-0 mt-1"
                                style={{ fontSize: "0.875rem" }}
                              >
                                Assets Bidded
                              </h6>
                            </div>

                            <div
                              className="flex-grow-1"
                              style={{
                                backgroundColor: "rgb(220,252,231)",
                                color: "rgb(22,163,74)",
                                padding: "12px",
                                borderRadius: "8px",
                                textAlign: "center",
                                minWidth: "150px",
                                flex: "1 1 calc(33.333% - 8px)",
                              }}
                            >
                              <h5
                                className="text-center m-0"
                                style={{ fontWeight: "600" }}
                              >
                                {filterTAUserDetails?.totalAssetApproved || 0}
                              </h5>
                              <h6
                                className="text-center m-0 mt-1"
                                style={{ fontSize: "0.875rem" }}
                              >
                                Assets Approved
                              </h6>
                            </div>

                            <div
                              className="flex-grow-1"
                              style={{
                                backgroundColor: "rgb(219,234,254)",
                                color: "rgb(59,130,246)",
                                padding: "12px",
                                borderRadius: "8px",
                                textAlign: "center",
                                minWidth: "150px",
                                flex: "1 1 calc(33.333% - 8px)",
                              }}
                            >
                              <h5
                                className="text-center m-0"
                                style={{ fontWeight: "600" }}
                              >
                                {filterTAUserDetails?.totalAssetPaymentDone ||
                                  0}
                              </h5>
                              <h6
                                className="text-center m-0 mt-1"
                                style={{ fontSize: "0.875rem" }}
                              >
                                Payment Done
                              </h6>
                            </div>
                          </div>
                        </>
                      )}

                      <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
                        <div className=" bg-glass shadow-sm p-3 mb-2 border mt-3 rounded">
                          <h6
                            className="mt-1"
                            style={{ color: "rgb(46,50,48)" }}
                          >
                            Basic Information
                          </h6>

                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">Business Type</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {/* {filterTAUserDetails.businessType || "NA"} */}
                                  {filterTAUserDetails?.businessType
                                    .split(" ")
                                    .map((word, index) =>
                                      index === 0
                                        ? word.charAt(0).toUpperCase() +
                                          word.slice(1).toLowerCase()
                                        : word.toLowerCase(),
                                    )
                                    .join(" ")}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">Company Name</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.companyName || "NA"}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">Contact Number</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.taUserPhone || "NA"}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="">Marital Status</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.maritalStatusOfApplicant ||
                                    "NA"}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">Residence Type</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {/* {filterTAUserDetails.residenceType || "NA"} */}
                                  {filterTAUserDetails?.residenceType
                                    ? filterTAUserDetails?.residenceType
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase(),
                                        )
                                        .join(" ")
                                    : "NA"}
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="">
                                  {filterTAUserDetails?.businessType ===
                                    "Partnership" ||
                                  filterTAUserDetails?.businessType ===
                                    "Private limited (Pvt Ltd)"
                                    ? "Firm Pan"
                                    : "Pan"}
                                </div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.businessType ===
                                    "Partnership" ||
                                  filterTAUserDetails?.businessType ===
                                    "Private limited (Pvt Ltd)"
                                    ? filterTAUserDetails?.firmPan
                                    : filterTAUserDetails?.pan || "NA"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className=" bg-glass shadow-sm p-3 mb-2 border mt-3 rounded">
                          <h6
                            className="mt-1"
                            style={{ color: "rgb(46,50,48)" }}
                          >
                            Business Profile
                          </h6>

                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="">Office Type</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.officeType
                                    ? filterTAUserDetails?.officeType
                                        .split(" ")
                                        .map((word, index) =>
                                          index === 0
                                            ? word.charAt(0).toUpperCase() +
                                              word.slice(1).toLowerCase()
                                            : word.toLowerCase(),
                                        )
                                        .join(" ")
                                    : "NA"}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">Yard Details</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.yardDetails || "NA"}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="">Total Experience</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.businessExperienceYears ||
                                    "NA"}{" "}
                                  Years
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">
                                  Vintage with MeraTractor
                                </div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.vintageWithMeratractorYears ||
                                    "NA"}{" "}
                                  Years
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="">Monthly Sales Unit</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.monthlyAverageSalesUnit ||
                                    "NA"}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">
                                  Monthly Sales Volume
                                </div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.monthlyAverageSalesVolume ? (
                                    <>
                                      ₹
                                      {Number(
                                        filterTAUserDetails?.monthlyAverageSalesVolume,
                                      ).toLocaleString("en-IN")}{" "}
                                    </>
                                  ) : (
                                    "NA"
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className=" bg-glass shadow-sm p-3 mb-2 border mt-3 rounded">
                          <h6
                            className="mt-1"
                            style={{ color: "rgb(46,50,48)" }}
                          >
                            Additional Information
                          </h6>

                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">Broker Background</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.brokerBackground ||
                                    "NA"}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className=""></div>
                                <div className="">Vehicle Category</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {/* {filterTAUserDetails.dealingInList} */}
                                  {filterTAUserDetails.dealingInList.join(", ")}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">
                                  Associated Financial
                                </div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.associatedFinanciers ||
                                    "NA"}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className=""></div>
                                <div className="">Residential Stability</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.residentialStabilityYears ||
                                    "NA"}
                                  Years
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">
                                  Vehicle Stockyard (Owned/Rented)
                                </div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.yardForStocking
                                    ? filterTAUserDetails?.yardForStocking
                                        .split(" ")
                                        .map((word, index) =>
                                          index === 0
                                            ? word.charAt(0).toUpperCase() +
                                              word.slice(1).toLowerCase()
                                            : word.toLowerCase(),
                                        )
                                        .join(" ")
                                    : "NA"}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="col-12">Recommended Amount</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.recommendedAmount
                                    ? filterTAUserDetails?.recommendedAmount
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>{" "}
                        <div className=" bg-glass shadow-sm p-3 mb-2 border mt-3 rounded">
                          <h6
                            className="mt-1"
                            style={{ color: "rgb(46,50,48)" }}
                          >
                            Reference
                          </h6>

                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="">Reference 1 Name</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {/* {filterTAUserDetails?.reference1Name || "NA"} */}
                                  {filterTAUserDetails?.reference1Name
                                    ? filterTAUserDetails?.reference1Name
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase(),
                                        )
                                        .join(" ")
                                    : "NA"}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="">Contact</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.reference1Phone
                                    ? filterTAUserDetails?.reference1Phone
                                    : "NA"}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="">Reference 2 Name</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {/* {filterTAUserDetails?.reference2Name || "NA"} */}
                                  {filterTAUserDetails?.reference2Name
                                    ? filterTAUserDetails?.reference2Name
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase(),
                                        )
                                        .join(" ")
                                    : "NA"}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6">
                              <div className="mt-2">
                                <div className="">Contact</div>
                                <div
                                  className="col-12"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {filterTAUserDetails?.reference2Phone
                                    ? filterTAUserDetails?.reference2Phone
                                    : "NA"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {filterTAUserDetails?.noOfPartners > 0 && (
                          <>
                            <div
                              className="table-responsive mt-2 text-center"
                              style={{ minHeight: "5vh", maxHeight: "40vh" }}
                            >
                              <h5
                                className="mt-4 d-flex flex-wrap justify-content-between"
                                style={{ color: "rgb(46,50,48)" }}
                              >
                                Partner Details
                              </h5>
                              {peronData && peronData.length > 0 ? (
                                <table className="table table-hover table-bordered">
                                  <thead className="thead-dark">
                                    <tr
                                      className="text-center"
                                      style={{
                                        fontSize: "small",
                                        position: "sticky",
                                        top: 0,
                                      }}
                                    >
                                      {businessHeaderv.map((columnName) => (
                                        <th className="col" key={columnName}>
                                          {columnName?.header}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {peronData && peronData.length === 0 ? (
                                      <div className="text-danger mt-2">
                                        No partner details found.
                                      </div>
                                    ) : (
                                      peronData?.map((rowData, rowIndex) => (
                                        <tr
                                          key={rowIndex}
                                          className="text-center"
                                        >
                                          {businessHeaderv.map(
                                            (column, colIndex) => (
                                              <td
                                                key={colIndex}
                                                className="col"
                                              >
                                                {rowData[column.dataKey]}
                                              </td>
                                            ),
                                          )}
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                              ) : (
                                <div className="text-danger text-center mt-2">
                                  No Partner Details Found.
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        <div
                          className="d-flex flex-wrap justify-content-end gap-2 mt-3 bg-white border-top pt-3"
                          style={{ position: "sticky", bottom: 0, zIndex: 2 }}
                        >
                          {((user?.role === "Business Analyst" &&
                            !filterTAUserDetails?.isCaseApprovedByBa) ||
                            canPrivilegedEdit) && (
                              <EditButton
                                id={filterTAUserDetails?.taOnboardingCaseId}
                              />
                            )}

                          {!filterTAUserDetails?.isCaseBusinessDetailsApprovedByBa &&
                            !filterTAUserDetails?.isCaseBusinessDetailsRejectedByBa &&
                            user?.role === "Business Analyst" && (
                              <>
                                {loadingbusDetails ? (
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    disabled
                                    id="loadingBtnTp"
                                  >
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Loading...
                                  </button>
                                ) : (
                                  <>
                                    <VerifyButton
                                      btnName={"Verify Business Details"}
                                      handleVerified={(e) => {
                                        handleVerifiedrRejectedBusDetails(
                                          e,
                                          filterTAUserDetails?.taOnboardingCaseId,
                                          "approve",
                                        );
                                      }}
                                    />
                                  </>
                                )}
                              </>
                            )}

                          {user?.role === "Business Analyst" &&
                            !filterTAUserDetails?.isCaseApprovedByBa &&
                            !filterTAUserDetails?.isCaseBusinessDetailsRejectedByBa && (
                              <RejectButton
                                btnName={"Reject Business Details"}
                                handleVerified={(e) => {
                                  handleVerifiedrRejectedBusDetails(
                                    e,
                                    filterTAUserDetails?.taOnboardingCaseId,
                                    "reject",
                                  );
                                }}
                              />
                            )}
                        </div>
                      </div>
                    </>
                  )}

                  {selected === "limitSettingDoc" && (
                    <>
                      <div className="d-flex flex-wrap justify-content-between text-align-center">
                        <div className="col-12 col-md-6 col-lg-5">
                          <h5
                            className="mt-4"
                            style={{ color: "rgb(46,50,48)" }}
                          >
                            Limit Setting Uploaded Documents
                          </h5>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                          <input
                            className="form-control"
                            name="search"
                            placeholder="Search by document name"
                            onChange={handleSearchLimitSetting}
                          />
                        </div>
                      </div>
                      <div className="mt-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
                        <button
                          className="btn btn-light shadow-sm"
                          style={{
                            fontSize: "14px",
                            color: "rgb(40, 180, 255)",
                            backgroundColor: "rgb(254, 254, 254)",
                            marginLeft: "2px",
                          }}
                          // onClick={() => {
                          //   downloadDocumentsAsZip(
                          //     filterTAUserDetails?.documents
                          //   );
                          // }}
                          onClick={() => {
                            setShowDocList(true);
                          }}
                        >
                          <i class="bi bi-file-zip me-2"></i>
                          Download Docs Zip
                        </button>
                        {/* Merged limit setting documents, once e-signed (Signzy link) */}
                        {filterTAUserDetails?.limitSettingEsign?.signedDocument && (
                          <a
                            href={filterTAUserDetails.limitSettingEsign.signedDocument}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-outline-success btn-sm"
                            title={
                              filterTAUserDetails.limitSettingEsign.signedAt
                                ? `E-Signed on ${new Date(
                                    filterTAUserDetails.limitSettingEsign.signedAt,
                                  ).toLocaleString("en-IN")}`
                                : "E-Signed"
                            }
                          >
                            <i className="bi bi-patch-check-fill me-2"></i>
                            View Merged Signed Document
                          </a>
                        )}
                      </div>
                      {limitSettingDocHeader.map((doc) => {
                        const documentData =
                          filterTAUserDetails?.documents?.find(
                            (d) => d.documentName === doc.dataKey,
                          );
                        const fileUrl = documentData?.documentPath;

                        return (
                          <>
                            {documentData?.isUploaded && (
                              <div
                                className="shadow-sm p-3 mb-2 border mt-4"
                                key={doc.dataKey}
                              >
                                <div className="d-flex flex-wrap justify-content-between">
                                  <div className="d-flex flex-wrap justify-content-start align-center col-12 col-md-7">
                                    <div
                                      style={{
                                        fontSize: "31px",
                                        marginRight: "5px",
                                        marginLeft: "-6px",
                                        color: "rgb(173, 106, 246)",
                                      }}
                                    >
                                      <i
                                        className="bi bi-file-image-fill"
                                        style={{
                                          backgroundColor: "rgb(255,255,255)",
                                        }}
                                      ></i>
                                    </div>
                                    <div
                                      className="me-2"
                                      style={{ marginTop: "10px" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {documentHeaderLabel(doc, filterTAUserDetails?.documents)}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="d-flex flex-wrap justify-content-end align-center col-12 col-md-5">
                                    {// (user?.role === "Business Analyst" && !filterTAUserDetails?.isLimitSettingDone) ||
                                    isDeveloper && (
                                      <div className="mt-2 text-end">
                                        <label
                                          htmlFor={documentData?.documentName}
                                          className="btn btn-outline-primary btn-sm mb-0"
                                          style={{
                                            fontSize: "16px",
                                            // color: "rgb(0,0,0)",
                                            // backgroundColor: "#ffffff",
                                            // paddingTop: "3px",
                                            // paddingBottom: "4px",
                                            // marginTop: "2px",
                                            // marginBottom: "5px",
                                            // marginLeft: "2px",
                                            // marginRight: "2px",
                                            // paddingRight: "2px",
                                            // paddingLeft: "1px",
                                            // width: "80px",
                                            // borderRadius: "4px",
                                            // fontFamily: "inherit",
                                            // fontWeight: "600",
                                            cursor: "pointer",
                                            border:
                                              "1px solid rgb(33, 150, 243)",
                                          }}
                                        >
                                          Upload
                                          <input
                                            type="file"
                                            id={documentData?.documentName}
                                            name={documentData?.documentName}
                                            style={{ display: "none" }}
                                            onChange={(e) =>
                                              handleUpload(
                                                e,
                                                documentData?.documentName,
                                                documentData?.documentID,
                                                filterTAUserDetails?.taOnboardingCaseId,
                                                // isRequired,
                                                doc?.header,
                                              )
                                            }
                                          />
                                        </label>
                                      </div>
                                    )}

                                    <div className="mt-2 ms-2">
                                      {documentData?.documentPath !== "" &&
                                        documentData?.documentPath !== null && (
                                          <>
                                            <ViewButton
                                              file={fileUrl}
                                              className="btn btn-outline-light me-2"
                                            />

                                            <DownloadButton file={fileUrl} />
                                          </>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        );
                      })}
                    </>
                  )}
                  {selected === "renewals" && (
                    <CaseRenewalsPanel
                      taOnboardingCaseId={
                        filterTAUserDetails?.taOnboardingCaseId
                      }
                    />
                  )}

                  {selected === "limitSetting" && (
                    <>
                      <div className="shadow-sm p-3 mb-2 border mt-3 rounded">
                        <h6 className="mt-1" style={{ color: "rgb(46,50,48)" }}>
                          Limit Setting Details
                        </h6>

                        <div className="row">
                          <div className="col-12 col-sm-6">
                            <div className="mt-2">
                              <div className="col-12 fw-bold">Credit Limit</div>
                              <div
                                className="col-12"
                                style={{ fontWeight: "500", fontSize: "1rem" }}
                              >
                                {indianCurrencyFormater(
                                  filterTAUserDetails?.creditLimit,
                                ) || "NA"}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-6">
                            <div className="mt-2">
                              <div className="fw-bold">Agreement Date</div>
                              <div
                                className="col-12"
                                style={{ fontWeight: "500", fontSize: "1rem" }}
                              >
                                {formatDateDDMMYYYY(
                                  new Date(filterTAUserDetails?.agreementDate),
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-12 col-sm-6">
                            <div className="mt-2">
                              <div className="col-12 fw-bold">
                                Limit Setup Date
                              </div>
                              <div
                                className="col-12"
                                style={{ fontWeight: "500", fontSize: "1rem" }}
                              >
                                {filterTAUserDetails?.taLimitSetupDate
                                  ? formatDateDDMMYYYY(
                                      new Date(
                                        filterTAUserDetails.taLimitSetupDate,
                                      ),
                                    )
                                  : "NA"}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-6">
                            <div className="mt-2">
                              <div className="fw-bold">Limit Expiry Date</div>
                              <div
                                className="col-12"
                                style={{ fontWeight: "500", fontSize: "1rem" }}
                              >
                                {filterTAUserDetails?.taLimitExpiryDate
                                  ? formatDateDDMMYYYY(
                                      new Date(
                                        filterTAUserDetails.taLimitExpiryDate,
                                      ),
                                    )
                                  : "NA"}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-12 col-sm-6">
                            <div className="mt-2">
                              <div className="col-12 fw-bold">
                                Upfront Margin
                              </div>
                              <div
                                className="col-12"
                                style={{ fontWeight: "500", fontSize: "1rem" }}
                              >
                                {filterTAUserDetails?.upfrontMargin || "NA"}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-6">
                            <div className="mt-2">
                              <div className="fw-bold">Vehicle Limit</div>
                              <div
                                className="col-12"
                                style={{ fontWeight: "500", fontSize: "1rem" }}
                              >
                                {filterTAUserDetails?.vehicleLimit || "NA"}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-12 col-sm-6">
                            <div className="mt-2">
                              <div className="col-12 fw-bold">
                                Financier Customer Id
                              </div>
                              <div
                                className="col-12"
                                style={{ fontWeight: "500", fontSize: "1rem" }}
                              >
                                {filterTAUserDetails?.financierCustomerId ||
                                  "NA"}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-6">
                            <div className="mt-2">
                              <div className="fw-bold">
                                Financier Virtual Account No
                              </div>
                              <div
                                className="col-12"
                                style={{ fontWeight: "500", fontSize: "1rem" }}
                              >
                                {filterTAUserDetails?.financierVirtualAccountNo ||
                                  "NA"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div>No Data</div>
              )}
            </>
          )}
        </div>
      </>
    );
  } catch (error) {
    console.log(error);
    return <ErrorHandler error={error} />;
  }
}

export default OnBoardingViewDetails;
